<template>
  <div class="boothDetail-container">
    <div class="booth-bg-box">
      <img class="bg-img" src="~@/assets/pc/showroom_bg_img.png" alt="">

      <div class="booth-nav">
        <div class="wd-1200">
          <div class="back-btn" @click="goBackBooth">
            <img class="img-common" src="~@/assets/pc/return_showroom_list_icon.png"/>
          </div>

          <div class="right-box">
            <div class="right-btn prev-btn" @click="prevHandle">
              <img class="img-common" src="~@/assets/pc/before_showroom_icon.png"/>
            </div>
            <div class="right-btn" @click="nextHandle">
              <img class="img-common" src="~@/assets/pc/next_showroom_icon.png"/>
            </div>
          </div>
        </div>
      </div>

      <div class="booth-logo">
        <img class="booth-logo-img img-common" :src="detailData.logo" alt="">
      </div>

      <div class="booth-name ellipsis left-perspective">
        <span>{{ detailData.name.length > 9 ? detailData.name.slice(0, 9) + '...' : detailData.name }}</span>
      </div>

      <div class="company-text left-perspective">
        <div class="guidance guidanceFirst clearFix">
          <b>
            <div class="img-box">
              <img src="~@/assets/pc/showroom_introduce_icon.png">
            </div>
          </b>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <img @click="handlePlayImage(detailData.introduce, '640px')"  class="company-text-img img-common" :src="detailData.introduce" />
      </div>

      <div class="production-img" v-if="productionImage">
        <div class="guidance clearFix">
          <b>
            <div class="img-box">
              <img src="~@/assets/pc/showroom_product_icon.png">
            </div>
          </b>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <img @click="handlePlayImage(productionImage, '640px')" class="img-common" :src="productionImage" />
      </div>

      <div class="production-more" v-if="productionImage" @click="goProduction"></div>

      <div class="video-box">
        <img
          v-if="!isShowVideo"
          @click="playVideo"
          class="video-box-img img-common"
          :src="detailData.boothVideoCover"
        />
        <img
          src="@/assets/pc/showroom_play_icon.png"
          class="play-btn"
          @click="playVideo"
        />
      </div>

      <div class="company-img-1">
        <div class="guidance clearFix">
          <b>
            <div class="img-box img-box-incline">
              <img src="~@/assets/pc/showroom_picture_icon.png">
            </div>
          </b>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <img @click="handlePlayImage(detailData.boothImage1, '720px')" class="company-img img-common" :src="detailData.boothImage1" />
      </div>

      <div class="company-img-2">
        <div class="guidance clearFix">
          <b>
            <div class="img-box img-box-incline">
              <img src="~@/assets/pc/showroom_picture_icon.png">
            </div>
          </b>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <img @click="handlePlayImage(detailData.boothImage2, '720px')" class="company-img img-common" :src="detailData.boothImage2" />
      </div>
    </div>

    <div class="booth-dialog-video" v-if="isShowVideo">
      <div class="booth-mask"></div>
      <i class="booth-dialog-close" @click="isShowVideo = false"></i>

      <video
        ref="boothVideo"
        width="100%"
        height="405"
        controls
        :src="detailData.boothVideo"
      >
      </video>
    </div>

    <el-dialog title="" :visible.sync="isShowImage" class="booth-dialog-image" :width="customWidth" @close="isShowImage = false">
      <img :src="imgUrl" />
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      const { params } = this.$route

      return {
        moduleInfo: this._moduleInfo[`booth_${params.moduleIndex}`],
        detailData: {},
        currentIndex: 0,
        productionImage: '', // 产品图
        isShowVideo: false,
        isShowImage: false,
        customWidth: '',
        imgUrl: ''
      };
    },
    watch: {
      $route: function() {
        this.getDetail();

        this.isShowVideo = false;
      },
    },
    methods: {
      playVideo() {
        // 播放视频
        this.isShowVideo = true;

        this.$nextTick(() => {
          this.$refs.boothVideo.play();
        })
      },
      prevHandle() {
        const boothList = this.moduleInfo;

        if (this.currentIndex === 0) {
          return;
        }

        this.$router.push({
          name: 'booth-detail',
          query: {
            id: boothList[this.currentIndex - 1].id,
          },
          params: {
            ...this.$route.params
          }
        });
      },
      nextHandle() {
        const boothList = this.moduleInfo;

        if (this.currentIndex === boothList.length - 1) {
          return;
        }

        this.$router.push({
          name: 'booth-detail',
          query: {
            id: boothList[this.currentIndex + 1].id,
          },
          params: {
            ...this.$route.params
          }
        });
      },
      goBackBooth() {
        this.$router.push({
          name: 'booth',
          params: {
            ...this.$route.params
          }
        });
      },
      goProduction() {
        this.$router.push({
          name: 'booth-production',
          query: {
            id: this.detailData.id,
          },
          params: {
            ...this.$route.params
          }
        });
      },
      getDetail() {
        const boothList = this.moduleInfo;
        const boothId = Number(this.$route.query.id);
        for (let i = 0; i < boothList.length; i++) {
          const item = boothList[i];
          if (item.id === boothId) {
            const { products } = item;

            if (Array.isArray(products) && products.length > 0) {
              this.productionImage = products[0].image;
            } else {
              this.productionImage = ''
            }

            this.detailData = item;
            console.log('this.detailData', this.detailData)
            this.currentIndex = i;
            break;
          }
        }
      },
      handlePlayImage(imgUrl, width) {
        this.imgUrl = imgUrl;
        this.customWidth = width;
        this.isShowImage = true;
      },
    },
    created() {
      this.getDetail();
    },
  };
</script>

<style lang="scss">
  .boothDetail-container {
    // min-width: 1200px;
    // position: relative;
    .booth-nav {
      background-color: rgba(0, 0, 0, 0.5);
      position: absolute;
      bottom: 0;
      width: 100%;
      /*height: 6.04vw;*/
      padding: 30px 0;

      .wd-1200 {
        color: #fff;
        height: 100%;

        .back-btn {
          box-sizing: border-box;
          float: left;
          width: 8.85vw;
          height: 2.91vw;
          line-height: 2.91vw;
          border-radius: 4px;
          text-align: center;
          cursor: pointer;
          font-size: 0.83vw;
          font-weight: bold;
          background-color: var(--themeColor);
        }

        .right-box {
          float: right;

          .right-btn {
            box-sizing: border-box;
            display: inline-block;
            width: 8.85vw;
            height: 2.91vw;
            border-radius: 4px;
            text-align: center;
            cursor: pointer;

            &.prev-btn {
              margin-right: 30px;
            }
          }
        }
      }
    }

    .el-dialog__wrapper {
      z-index: 999999 !important;
    }

    .booth-dialog-image {
      .el-dialog__header {
        padding: 0;
      }

      .el-dialog__headerbtn {
        top: 8px;
        right: 8px;
      }

      img {
        width: 100%;
        min-height: 200px;
        display: block;
      }
    }

    .booth-dialog-close {
      cursor: pointer;
      position: absolute;
      right: -50px;
      top: 0;
      display: block;
      height: 36px;
      width: 36px;
      background-image: url("~@/assets/pc/botth_dialog_close.png");
      background-size: cover;
    }
    
    .booth-dialog-video {
      z-index: 90;
      width: 720px;
      height: 405px;
      background-color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -260px;
      margin-left: -360px;

      .booth-mask {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0,0,0,0.3);
        z-index: -1;
      }
    }

    .play-button {
      cursor: pointer;
      width: 64px;
      height: 64px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -32px;
      margin-left: -32px;

      img {
        animation: scaleDraw 3s ease-in-out infinite;
        display: inline-block;
        height: 100%;
        width: 100%;
      }
    }
  }
</style>
